export default __webpack_public_path__ + "static/3-6e2bd0b02334e4f5ba6a5656e679b839.jpg";